import React, { Component } from "react"

/* Constants */
import { utils } from "../constants"


/* THE PAYOUT TABLE

   What a stake pays is read off the player's own hand. What it costs is read off the
   dealer's — the same table, the other way round. Neither has anything to do with the
   other boxes: a hand is held against the dealer's five cards and nothing else.

   One table of three columns, as it is printed on the cloth — a block per stake read
   correctly but ran to thirty-nine lines, and twelve of the thirteen in the first block
   said the same thing.

   The columns are shares of the width rather than a fixed number of pixels. Fixed widths
   were what crushed "DOUBLE" and "SUPER" together the first time this was tried: a
   heading needs whatever room its word needs, and 62px was not it. minmax(0, 1fr) cannot
   overflow whatever the panel is narrowed to. */
const ROWS = [
    { name: "Каре", bet: "1:1", double: "5:1", super: "15:1" },
    { name: "Пять картинок", bet: "1:1", double: "4:1", super: "12:1" },
    { name: "Ню Ню", bet: "1:1", double: "3:1", super: "10:1" },
    { name: "Ню 9", bet: "1:1", double: "2:1", super: "9:1" },
    { name: "Ню 8", bet: "1:1", double: "2:1", super: "8:1" },
    { name: "Ню 7", bet: "0,5:1", double: "1:1", super: "3,5:1", half: true },
    { name: "Ню 6", bet: "1:1", double: "1:1", super: "6:1" },
    { name: "Ню 5", bet: "1:1", double: "1:1", super: "5:1" },
    { name: "Ню 4", bet: "1:1", double: "1:1", super: "4:1" },
    { name: "Ню 3", bet: "1:1", double: "1:1", super: "3:1" },
    { name: "Ню 2", bet: "1:1", double: "1:1", super: "2:1" },
    { name: "Ню 1", bet: "1:1", double: "1:1", super: "1:1" },
    { name: "Нет игры", bet: "1:1", double: "1:1", super: "1:1" }
]

class GamePayout extends Component {

    minmax = () => {
        const { max, min, currency } = this.props
        return <span className="minmax">&nbsp;&nbsp; {utils.convertor(min, currency)} - {utils.convertor(max, currency)}</span>
    }

    render = () => {
        return (
            /* game-payout-box is the package's own wrapper for this panel, and what it
               carries is the gap that clears the game title fixed across the top —
               50px, dropping to 0 under 768px and 10px on a short landscape screen.
               Starting the panel with a bare .row instead, as this did, left the first
               header sliding under the title. Reusing the class keeps all three cases
               right without a copy of the numbers here. */
            <div className="game-payout-box">

                <div className="row">
                    <p>ВЫПЛАТЫ {this.minmax()}</p>
                </div>

                <div className="niu-payout">

                    <div className="niu-payout-row niu-payout-head">
                        <p>Комбинация</p>
                        <p>BET</p>
                        <p>DOUBLE</p>
                        <p>SUPER</p>
                    </div>

                    {ROWS.map(row =>
                        <div className={`niu-payout-row ${row.half ? "niu-payout-half" : ""}`} key={row.name}>
                            <p>{row.name}</p>
                            <p>{row.bet}</p>
                            <p>{row.double}</p>
                            <p>{row.super}</p>
                        </div>
                    )}

                </div>

                <div className="row">
                    <p>ПОЛОВИНА НА НЮ 7</p>
                </div>

                <div className="niu-note">
                    <p>
                        Выигрыш с комбинацией «Ню 7» оплачивается в половинном размере — он уже
                        учтён в таблице: BET — 0,5:1, DOUBLE BET — 1:1, SUPER DOUBLE — 3,5:1.
                    </p>
                    <p>
                        Проигрыш комбинации «Ню 7» у дилера удерживается полностью:
                        1 ставка на BET, 2 на DOUBLE BET и 7 на SUPER DOUBLE.
                    </p>
                </div>

                <div className="row">
                    <p>УДЕРЖАНИЕ СТАВКИ</p>
                </div>

                <div className="niu-note">
                    <p>
                        Проигрыш может превышать номинал ставки, поэтому при её постановке
                        со счёта удерживается максимально возможная сумма проигрыша:
                        одна ставка на BET, пять на DOUBLE BET и пятнадцать на SUPER DOUBLE.
                    </p>
                    <p>
                        Всё, что раздача не забрала, возвращается на счёт сразу после
                        вскрытия карт дилера — вместе с выигрышем, если он есть.
                    </p>
                </div>

                <div className="row">
                    <p>СТАРШИНСТВО КАРТ</p>
                </div>

                <div className="niu-note">
                    <p>
                        При одинаковых комбинациях сравнение идёт по старшей карте:
                        К &gt; Д &gt; В &gt; 10 &gt; 9 &gt; 8 &gt; 7 &gt; 6 &gt; 5 &gt; 4 &gt; 3 &gt; 2 &gt; Т.
                        Туз — младшая карта, поэтому каре двоек старше каре тузов.
                    </p>
                    <p>
                        Если совпадают все номиналы, сравнение идёт по масти старшей карты:
                        ♠ &gt; ♥ &gt; ♣ &gt; ♦. Ничьих в игре не бывает.
                    </p>
                </div>

            </div>
        )
    }
}

export default GamePayout
